<template>
  <v-col align="center">
    <div v-once :id="id" class="hbsform" />
  </v-col>
</template>

<script>
export default {
  name: 'HubspotForm',
  props: {
    eventLabel: {
      type: String,
      required: false,
      default: 'empreendedores',
    },
    id: {
      type: String,
      required: false,
      default: 'hbsform',
    },
    formId: {
      type: String,
      required: true,
    },
    analyticsData: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mounted() {
    const createForm = () => {
      window.hbspt.forms.create({
        portalId: '7009007',
        formId: this.formId,
        target: `#${this.id}`,
        // onFormSubmit() {
        //   console.log('Enviado');
        //   console.log(this.analyticsData);
        //   this.analytics(this.analyticsData);
        // },
      });
    };

    if (window.hbspt) {
      // console.log('já existe js do hs carregado');
      createForm();
    } else {
      // console.log('Não existe js do hs carregado');

      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
        createForm();
      });
    }

    const popupIcon = document.querySelector('.form-popup-icon');
    const popupCloseBtn = document.querySelector('.form-popup-close');
    const popup = document.querySelector('.form-popup');
    const openPopup = () => {
      if (!popup.classList.contains('popup-open')) {
        popup.classList.add('popup-open');
      }
    };
    const closePopup = () => {
      if (popup.classList.contains('popup-open')) {
        popup.classList.remove('popup-open');
      }
    };
    if (popupIcon && popupCloseBtn) {
      popupIcon.addEventListener('click', openPopup);
      popupIcon.addEventListener('mouseover', openPopup);
      popupCloseBtn.addEventListener('click', closePopup);
    }
  },
  methods: {
    analytics(data) {
      // this.$analytics(eventCategory, eventAction, eventLabel, eventValue);
      this.$analytics(data);
    },
  },
};
</script>

<style lang="css">
.hbsform {
  max-width: 600px;
}
.teste {
  font-family: 'Proxima Nova' !important;
}

.new-color .teste {
  font-family: 'metropolisregular' !important;
}
</style>
